/**
 * Legacy wrapper — callers that don't have a React hook context.
 * Prefer useTenantFormat().formatMoney in components.
 */
export function formatINR(n) {
  if (n == null || n === '' || n === '—') return '—';
  const num = Number(n);
  if (isNaN(num)) return '—';
  try { return '₹' + num.toLocaleString('en-IN', { maximumFractionDigits: 2 }); }
  catch { return '₹' + String(num); }
}
